class AuthSettingsController implements ng.IComponentController {
   
    constructor() {
        'ngInject';
    }
}

export const authSettingsComponent : ng.IComponentOptions = {
    controller : AuthSettingsController,
    template : require('./authsettings.html')
};



// WEBPACK FOOTER //
// ./src/app/authsettings/components/authsettings.component.ts